(function () {
    'use strict';

    angular
        .module('app.cart')
        .factory('CartService', CartService);

    CartService.$inject = ['$http', '$q'];

    function CartService($http, $q) {
        var service = {
            getCart: getCart,
            updateCart: updateCart,
            InsertWithParams: InsertWithParams,
            Insert: Insert,
            Increment: Increment,
            Decrement: Decrement,
            Update: Update,
            Delete: Delete,
            IsInCart: IsInCart
        };

        return service;

        function getCart(params) {
            var deferred = $q.defer();
            var url = "/Cart";
            if (params && params.Id) {
                url += "/" + params.Id;
            }
            if (params && params.CartType) {
                url += "?CartType=" + params.CartType;
            }
            $http.get(url)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function IsInCart(params) {
            var deferred = $q.defer();

            var url = "/Cart/IsInCart";
            $http.get(url, {
                    params: params
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function updateCart(cart) {
            var deferred = $q.defer();

            $http.put("/Cart/" + cart.Id, cart)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function InsertWithParams(params) {
            var cartProduct = {
                ProductId: params.productID,
                Quantity: params.quantity,
                CartType: params.CartType,
                CartId: params.cartId,
                VariantValues: JSON.stringify(params.variantValues)
            };
            return Insert(cartProduct);
        }

        function Insert(cartProduct) {
            var deferred = $q.defer();

            $http.post("/Cart/Product/" + cartProduct.ProductId + "/" + cartProduct.Quantity, cartProduct)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Increment(cartProduct) {
            var deferred = $q.defer();

            $http.put("/Cart/Product/" + cartProduct.ProductId + "/" + (cartProduct.Quantity + cartProduct.Product.DefaultIncrement), {
                    Id: cartProduct.Id,
                    ProductId: cartProduct.ProductId,
                    Quantity: cartProduct.Quantity + cartProduct.Product.DefaultIncrement
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Decrement(cartProduct) {
            var deferred = $q.defer();

            $http.put("/Cart/Product/" + cartProduct.ProductId + "/" + (cartProduct.Quantity - cartProduct.Product.DefaultIncrement), {
                    Id: cartProduct.Id,
                    ProductId: cartProduct.ProductId,
                    Quantity: cartProduct.Quantity - cartProduct.Product.DefaultIncrement
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Update(cartProduct) {
            var deferred = $q.defer();

            $http.put("/Cart/Product/" + cartProduct.ProductId + "/" + cartProduct.Quantity, {
                    Id: cartProduct.Id,
                    ProductId: cartProduct.ProductId,
                    Quantity: cartProduct.Quantity
                })
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function Delete(cartProduct) {
            var deferred = $q.defer();

            $http.delete("/Cart/Product/" + cartProduct.Id)
                .then(complete)
                .catch(failed);

            function complete(response) {
                deferred.resolve(response.data);
            }

            function failed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }
    }
})();